import React, { useEffect } from "react";
import {
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
  TableContainer,
  Paper,
  Chip,
  Button,
  Typography,
  Box,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import moment from "moment";
import { DOWNLOAD_INVOICE } from "../api-calls/api-urls";
import { useDispatch, useSelector } from "react-redux";
import { getLanguagedataFunction } from "../utilities/language";

const MyTableBody = (props) => {
  const dispatch = useDispatch();
  const ln = useSelector((state) => state.allUsers.language_json);

  React.useEffect(() => {
    getLanguagedataFunction(dispatch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log(props.list);
  }, [props.list]);

  const handleDownloadInvoice = async (item) => {
    const url = `${process.env.REACT_APP_API_URL}${DOWNLOAD_INVOICE}/${item.order_id}/${item.user_id}`;
    window.open(url, "_blank");
  };

  const rows = props.list ? props.list.filter((item) => item.order_id) : [];

  if (!ln) return null;

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        border: "1px solid #e8edf2",
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#f0f6ff" }}>
            {["#", ln.date, ln.plan, ln.price, ln.invoice].map((heading) => (
              <TableCell
                key={heading}
                sx={{
                  fontWeight: 700,
                  fontSize: "13px",
                  color: "#0a1f41",
                  borderBottom: "2px solid #d7edff",
                  py: 1.5,
                  px: 2.5,
                  whiteSpace: "nowrap",
                }}
              >
                {heading}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length > 0 ? (
            rows.map((item, index) => (
              <TableRow
                key={index}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#ffffff" : "#fafbff",
                  "&:hover": { backgroundColor: "#eef5ff" },
                  "&:last-child td": { borderBottom: 0 },
                  transition: "background-color 0.15s ease",
                }}
              >
                <TableCell
                  sx={{ color: "#6b778c", fontSize: "13px", py: 1.75, px: 2.5, width: "48px" }}
                >
                  {index + 1}
                </TableCell>

                <TableCell sx={{ py: 1.75, px: 2.5, whiteSpace: "nowrap" }}>
                  <Typography sx={{ fontSize: "14px", color: "#0a1f41", fontWeight: 500 }}>
                    {moment(item.createdAt).format("DD MMM YYYY")}
                  </Typography>
                  <Typography sx={{ fontSize: "12px", color: "#8a96a8", mt: 0.25 }}>
                    {moment(item.createdAt).format("hh:mm A")}
                  </Typography>
                </TableCell>

                <TableCell sx={{ py: 1.75, px: 2.5 }}>
                  <Box
                    sx={{
                      display: "inline-block",
                      px: 1.5,
                      py: 0.5,
                      borderRadius: "6px",
                      backgroundColor: "#e8f0fe",
                      color: "#1a56db",
                      fontSize: "13px",
                      fontWeight: 600,
                      textTransform: "capitalize",
                    }}
                  >
                    {(() => {
                      const plan = props.allPlans?.find(p => String(p._id) === String(item.subscription_id));
                      const name = plan ? plan.packageName : (item.subscription_details?.packageName || item.subscription_details?.plan_name || "Plan");
                      return `${name} (${ln[item.duration_details.duration] || item.duration_details.duration})`;
                    })()}
                  </Box>
                </TableCell>

                <TableCell sx={{ py: 1.75, px: 2.5 }}>
                  {parseFloat(item.duration_details.price?.$numberDecimal) === 0 ? (
                    <Chip
                      label="Free"
                      size="small"
                      sx={{
                        backgroundColor: "#e6f4ea",
                        color: "#2e7d32",
                        fontWeight: 700,
                        fontSize: "12px",
                        height: "24px",
                      }}
                    />
                  ) : (
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#0a1f41" }}>
                      ₹ {item.duration_details.price.$numberDecimal}
                    </Typography>
                  )}
                </TableCell>

                <TableCell sx={{ py: 1.75, px: 2.5 }}>
                  <Button
                    size="small"
                    startIcon={<DownloadIcon sx={{ fontSize: "16px !important", opacity: 1, visibility: "visible" }} />}
                    onClick={() => handleDownloadInvoice(item)}
                    sx={{
                      fontSize: "13px",
                      fontWeight: 600,
                      textTransform: "none",
                      color: "#227dc3",
                      px: 1.5,
                      py: 0.5,
                      borderRadius: "6px",
                      "& svg": {
                        color: "#227dc3",
                        fill: "#227dc3"
                      },
                      "&:hover": {
                        backgroundColor: "#e8f4ff",
                      },
                    }}
                  >
                    {ln.download_invoice}
                  </Button>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5} sx={{ textAlign: "center", py: 5, color: "#8a96a8" }}>
                No subscription history found.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MyTableBody;
